import React from 'react';

import Flex from '@common/blocks/FlexBlock';
import Text from '@common/blocks/TextBlock';
import Form from '@common/blocks/FormBlock';
import List from '@common/blocks/ListBlock';
import Image from '@common/blocks/ImageBlock';
import Button from '@common/blocks/ButtonBlock';
import Event from '@common/blocks/EventBlock';
import Video from '@common/blocks/VideoBlock';
import Product from '@common/blocks/Product';
import AcademyImageList from '@common/blocks/academy/image-list/ImageList';
import AcademyLinkList from '@common/blocks/academy/link-list/LinkList';

// List of dynamic components
const components = {
  ContentfulFlexBlock: Flex,
  ContentfulTextBlock: Text,
  ContentfulForm: Form,
  ContentfulListBlock: List,
  ContentfulImageBlock: Image,
  ContentfulButton: Button,
  ContentfulEvent: Event,
  ContentfulVideo: Video,
  ContentfulProduct: Product,
  ContentfulAcademyButton: Button,
  ContentfulAcademyImageList: AcademyImageList,
  ContentfulAcademyLinkList: AcademyLinkList
}

const Blocks = ({ data }) => {
  const Component = components[data?.__typename];
  if (Component) {
    return <Component data={data} />;
  }
  console.log('Missing component for type: ' + data?.__typename);
  return null;
}

export default Blocks
